import * as React from 'react';

interface RoomTitleProps {
  description?: string;
  name?: string;
  hideRoomTitleToA11y?: boolean;
}
export const RoomTitle: React.FunctionComponent<RoomTitleProps> = ({ description, name, hideRoomTitleToA11y }: RoomTitleProps) => {
  if (!name && !description) {
    return null;
  }

  return (
    <>
      {name && (
        <h3 className="uitk-type-heading-600" data-stid="room-info-title-heading" aria-hidden={Boolean(hideRoomTitleToA11y)}>
          {name}
        </h3>
      )}
      {description && (
        <p className="uitk-type-subheading content all-t-margin-one uitk-type-regular" data-stid="room-info-title-view">
          {description}
        </p>
      )}
    </>
  );
};
